import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CERT_STAGE_LABELS, isCertStage, isLoopStage } from './stages.js';
export function StageChip({ stage, className }) {
    if (!isCertStage(stage)) {
        throw new Error(`StageChip: unknown stage "${String(stage)}" — use the CertStage enum (Contract C19)`);
    }
    const label = CERT_STAGE_LABELS[stage];
    const loop = isLoopStage(stage);
    return (_jsxs("span", { className: className, "data-stage-chip": stage, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '0 6px',
            border: '1px solid var(--border-control)',
            borderRadius: 'var(--radius-sm)',
            background: 'transparent',
            color: 'var(--text)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--fs-xs)',
            fontWeight: 600,
            lineHeight: '18px',
            whiteSpace: 'nowrap',
        }, children: [_jsx("span", { className: "sr-only", children: "Stage: " }), loop ? _jsx("span", { "aria-hidden": "true", children: "\u21BB" }) : null, _jsx("span", { children: label }), loop ? _jsx("span", { className: "sr-only", children: " (ongoing)" }) : null] }));
}
//# sourceMappingURL=StageChip.js.map